import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

// Language URL mappings
export const languageUrlMap = {
  sv: 'svenska',
  ar: 'arabiska', 
  en: 'english',
  tr: 'turkiska',
  fa: 'persiska',
  so: 'somaliska',
  pl: 'polska',
  es: 'spanska',
  de: 'tyska'
};

// Reverse mapping (URL to language code)
export const urlToLanguageMap = Object.fromEntries(
  Object.entries(languageUrlMap).map(([code, url]) => [url, code])
);

// Component that wraps a page and sets the language based on URL
const LocalizedRoute = ({ children, lang }) => {
  const { i18n } = useTranslation();
  const hasSetLang = useRef(false);

  useEffect(() => {
    hasSetLang.current = false;
  }, [lang]);

  useEffect(() => {
    if (lang && i18n.language !== lang && !hasSetLang.current) {
      hasSetLang.current = true;
      i18n.changeLanguage(lang);
      localStorage.setItem('i18nextLng', lang);
    }
  }, [lang, i18n]);

  return children;
};

export default LocalizedRoute;

// Helper to generate all localized routes for a page
export const generateLocalizedRoutes = (basePath, Component, isProtected = false) => {
  const routes = [];
  
  Object.entries(languageUrlMap).forEach(([langCode, langUrl]) => {
    // Skip Swedish as it uses the base path
    if (langCode === 'sv') return;
    
    const localizedPath = `${basePath}-${langUrl}`;
    routes.push({
      path: localizedPath,
      lang: langCode,
      Component,
      isProtected
    });
  });
  
  return routes;
};
